module.exports = __webpack_public_path__ + "static/img/mzsm_e_font.3b1efb1c.svg";